import { useState } from "react";
import { useEffect, useRef } from "react";
import AppLayout from "./AppLayout";

let first = true;

function AppLayoutLoading({ loader = null }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!first) {
      return;
    }
    const t = document.getElementById("initial-template");
    if (!t) {
      return;
    }
    const clone = t.content.cloneNode(true);

    ref.current.appendChild(clone);
    first = false;
  }, []);

  return (
    <div ref={ref}>
      {!first && <AppLayout>{loader ? { loader } : <div className="loading" />}</AppLayout>}
    </div>
  );
}

export default AppLayoutLoading;
